import {
    BG_Draft_UPLOAD, BG_Draft_UPLOAD_ERROR,
    BG_Draft_UPDATE,BG_Draft_UPDATE_ERROR,
    BG_Draft_GET, BG_Draft_GET_ERROR,
    PO_DETAIL_GET, PO_DETAIL_GET_ERROR,
    BG_DOC_DETAIL_GET, BG_DOC_DETAIL_GET_ERROR,
    PO_BG_Draft_UPLOAD, PO_BG_Draft_UPLOAD_ERROR,
    PO_BG_Draft_UPDATE, PO_BG_Draft_UPDATE_ERROR,
    PO_BG_Draft_ACTION,PO_BG_Draft_ACTION_ERROR,
} from '../type'

const initialState = {
    bgUpload: null,
}
export default function bgDraftDocReducer(state = initialState, action) {
    switch (action.type) {

        case PO_BG_Draft_UPLOAD:
            return {
                ...state,
                pobgDraftUpload: action.payload,
                loading: false
            }
        case PO_BG_Draft_UPLOAD_ERROR:
            return {
                ...state,
                pobgDraftUpload: action.payload,
                loading: false
            }

        case PO_BG_Draft_ACTION:
            return {
                ...state,
                pobgDraftAction: action.payload,
                loading: false
            }
        case PO_BG_Draft_ACTION_ERROR:
            return {
                ...state,
                pobgDraftAction: action.payload,
                loading: false
            }


        case PO_BG_Draft_UPDATE:
            return {
                ...state,
                pobgDraftUpload: action.payload,
                loading: false
            }
        case PO_BG_Draft_UPDATE_ERROR:
            return {
                ...state,
                pobgDraftUpload: action.payload,
                loading: false
            }

        case BG_Draft_UPLOAD:
            return {
                ...state,
                bgDraftUpload: action.payload,
                loading: false
            }
        case BG_Draft_UPLOAD_ERROR:
            return {
                ...state,
                bgDraftUpload: action.payload,
                loading: false
            }

        case BG_Draft_UPDATE:
            return {
                ...state,
                bgDraftUpdate: action.payload,
                loading: false
            }
        case BG_Draft_UPDATE_ERROR:
            return {
                ...state,
                bgDraftUpdate: action.payload,
                loading: false
            }

        case BG_Draft_GET:
            return {
                ...state,
                bgDraftGet: action.payload,
                loading: false
            }
        case BG_Draft_GET_ERROR:
            return {
                ...state,
                bgDraftGet: action.payload,
                loading: false
            }

        case PO_DETAIL_GET:
            return {
                ...state,
                poDetail: action.payload,
                loading: false
            }
        case PO_DETAIL_GET_ERROR:
            return {
                ...state,
                poDetail: action.payload,
                loading: false
            }
        case BG_DOC_DETAIL_GET:
            return {
                ...state,
                BGDocTable: action.payload,
                loading: false
            }
        case BG_DOC_DETAIL_GET_ERROR:
            return {
                ...state,
                BGDocTable: action.payload,
                loading: false
            }

        default: return state
    }


}

